import type { FC, MouseEvent as ReactMouseEvent } from 'react';

import classNames from 'classnames';

import ICONS from '../../../icons/constants';
import Icon from '../../../icons/icon';
import type { TagValueComponentProps } from '../../../ui/select_field/types';
import Ellipsis from '../../ellipsis/ellipsis';
import TooltipTrigger from '../../tooltip_trigger/tooltip_trigger';

import styles from './select_field_tag_value.module.css';

const SelectFieldTagValue: FC<TagValueComponentProps> = (props) => {
  const { onDelete, value, isDisabled, onCopySelectionToggle } = props;
  const hideSideButtons = isDisabled || value.isCopyMode;

  const handleDeleteClick = (): void => {
    if (isDisabled) {
      return;
    }

    onDelete?.(value);
  };

  const handleMouseDown = (event: ReactMouseEvent<HTMLDivElement>): void => {
    if (value.isCopyMode) {
      event.preventDefault();
    }
  };

  return (
    <div
      className={classNames(styles.root, {
        [styles.disabled]: isDisabled,
        [styles.copy_mode]: value.isCopyMode,
        [styles.selected]: value.isCopyMode && value.isSelectedToCopy,
      })}
      onMouseDown={handleMouseDown}
      onClick={() => {
        if (value.isCopyMode) {
          onCopySelectionToggle?.();
        }
      }}
      role="listitem"
    >
      <button
        type="button"
        className={classNames(styles.delete, {
          [styles.hidden]: hideSideButtons,
        })}
        disabled={hideSideButtons}
        onClick={hideSideButtons ? undefined : handleDeleteClick}
      >
        <Icon icon={ICONS.CrossMark} size={10} />
      </button>
      <div className={styles.label}>
        <Ellipsis
          componentProps={{ className: styles.wrap_text }}
          tooltipText={isDisabled ? value.label : undefined}
          component="span"
          tooltipPlacement="right"
        >
          {value.label}
        </Ellipsis>
        {value.warningLabel ? (
          <TooltipTrigger tooltipText={value.warningLabel}>
            <Icon
              className={styles.warning_icon}
              icon={ICONS.Warning}
              size={12}
            />
          </TooltipTrigger>
        ) : null}
      </div>
    </div>
  );
};

export default SelectFieldTagValue;
